import React from 'react';
import './Cards.css';
import CardItem from './CardItem';


function Ongoing() {
  return (
    <div className='cards' style={{backgroundColor:"#dcdcdc"}}>
      
    <h1>Ongoing Projects</h1>
    <div className='cards__container'>
   
       
          <div className='cards__items'>
          <CardItem
            src='images/BAM 27/BAM 27 (3).jpg'
            text='RENNOVATION WORK'
            label='BA 40'
            location='Maradhan'
            price='LKR 15 Million'
            description='G+ 3 Story House'
            path='/ba40'
          />
          </div>
          <div className='cards__items'>
          <CardItem
            src='images/BAM 26/BAM 26 (4).jpg'
            text='TWO STORY HOUSE'
            label='BA 39'
            location='Brandiyawaththa'
            price='LKR 8 Million'
            description='3 Bedroom House-1st Floor'
            path='/ba39'
          />
          </div>
          <div className='cards__items'>
          <CardItem
            src='images/Ba38/Ba 38 (6).jpg'
            text='RENNOVATION WORK'
            label='BA 38'
            location='Kollupitiya'
            price='LKR 7 Million'
            description='G+ 5 Story Building Slab'
            path='/ba38'
          />
          </div>
          <div className='cards__items'>
          <CardItem
            src='images/Ba37/Ba 37 (6).jpg'
            text='TWO STORY HOUSE'
            label='BA 37'
            location='Dehiwela'
            price='LKR 25 Million'
            description='3 Bedroom House'
            path='/ba37'
          />
          </div>
          </div>
          <div className='cards__container'>
          <div className='cards__items'>
          <CardItem
            src='images/Ba31/Ba 31 (1).jpg'
            text='EXTERNEL PLUMBING'
            label='BA 31'
            location='Dummalasooriya'
            price='LKR 40 Million'
            description='Manhole Work'
            path='/ba31'
          />
        </div>
        <div className='cards__items'>
          <CardItem
            src='images/Shafiya/Shafiya (1).jpg'
            text='SAFIYYA FASHION'
            label='BA 30'
            path='/ba30'
            location='Maligawaththa'
            price='LKR 70 Million'
            description='G+ 4 Story Building'
            icon='images/loc.png'
          />
          </div>
      </div>  
  </div>
);
}

export default Ongoing;
